import type { TestimonialBlock as TestimonialBlockType } from "@/types";

/** Pull-quote testimonial (CD band). A large light-weight blockquote with the
 *  attribution as an eyebrow beneath — no rule, no dash. Sits in whatever band
 *  the block's background modifier sets (slate or stone in the CD template). */
export function TestimonialBlock({ block }: { block: TestimonialBlockType }) {
  const { text, attribution } = block.props;
  if (!text) return null;
  return (
    <figure className="block block--quote">
      <blockquote className="block--quote__text">{text}</blockquote>
      {attribution ? (
        <figcaption className="eyebrow block--quote__attr">{attribution}</figcaption>
      ) : null}
    </figure>
  );
}
